import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'effectiveCapacity' })
export class EffectiveCapacityPipe implements PipeTransform {
	transform(balloonCapacity: number | null | undefined, capacityReduction: number | null | undefined): number {
		const capacity = balloonCapacity || 0;
		const reduction = capacityReduction || 0;
		return Math.max(0, capacity - reduction);
	}
}
